import { useState } from "react";
import { Modal, ModalHeading } from "@sainsburys-tech/luna-modal";
import {
  ButtonGroupWrapper,
  FilledButton,
  IconButton,
  OutlinedButton,
} from "@sainsburys-tech/luna-button";
import { TextInputField } from "@sainsburys-tech/luna-form";
import { GridWrapper, GridItem } from "@sainsburys-tech/luna-grid";
import { Plus, Delete, Tick } from "@sainsburys-tech/luna-icons";
import AutoComplete from "../../SharedComponents/AutoComplete";
import { Table } from "@sainsburys-tech/luna-table";
import { useGetApi } from "../../../Redux/Hooks/useGetApi";
import { endpoints } from "../../../ApiEndPoints/apiEndPoints";
import { SelectField } from "@sainsburys-tech/luna-form";
import { consolelog } from "../../../helpers/consolelog";
import {
  CustomerTypeOptions,
  FIELDS,
  FormInputLevels,
} from "../../../Interfaces/ILegacyDuTypeFormField";
import { ILegacyDuTypeFormValueType } from "../../../Types/legacyDuTypeFormProps";
import { Form } from "@sainsburys-tech/luna-form";
import {
  IInitialStateLegacyType,
  iInitialStateLegacyType,
} from "../../../Interfaces/ILegacyContainerType";
import { CheckboxField } from "@sainsburys-tech/luna-form";
import { setCheckBoxData } from "../../../helpers/rowMatchHelper";

import LoadingIndicator from "../../Loading";
import { IsNullEmptyUndefined } from "./duTypeValidations";
import { Checkbox, FieldInfo, Label } from "@sainsburys-tech/luna-form";

const PRFFERED_CHECK_WARNING = (containerType: string | undefined) =>
  containerType
    ? `Preferred flag is already set in ${containerType}. Selecting this will override existing.`
    : "";

const CANT_DELETE_MESSAGE = (
  container: ILegacyDuTypeFormValueType | undefined
) =>
  `Prior deleting, set the preferred flag for legacy container ${container?.containerType} (${container?.customerType}) in other association.`;

interface IParams {
  filter: string;
  isEnabled: boolean;
}

const LegacyContainerPopup = (props: any) => {
  const [state, setState] = useState<IInitialStateLegacyType>(
    iInitialStateLegacyType
  );
  const [preferredCheckWarning, setPreferredCheckWarning] =
    useState<string>("");
  const [legacyContainers, setLegacyContainers] = useState<
    ILegacyDuTypeFormValueType[]
  >(props.legacyContainersData);
  const [isAddDisabled, setIsAddDisabled] = useState<boolean>(true);
  const [message, setMessage] = useState<string>();
  const [paramsData, setParamsData] = useState<IParams>({
    filter: "",
    isEnabled: false,
  });
  const [onDeleteCheckParams, setOnDeleteCheckParams] = useState<IParams>({
    filter: "",
    isEnabled: false,
  });
  const [onDeleteMessage, setOnDeleteMessage] = useState<string>();
  const [itemToDelete, setItemToDelete] =
    useState<ILegacyDuTypeFormValueType>();

  const handleChange = (event: any, isCheckbox: boolean = false) => {
    setMessage("");
    let targetValue: any;
    targetValue = event.target.value;

    if (event.target.name === FIELDS.customerType.name) {
      duplicateEntryValidation(event.target.value, state.values.containerType);
    }

    if (event.target.name === FIELDS.isDefault.name) {
      if (event.target.checked) {
        setPreferredCheckWarning(
          PRFFERED_CHECK_WARNING(apiResponse?.data?.value[0]?.ContainerType)
        );
      } else {
        setPreferredCheckWarning("");
      }
    }

    setState((initialState: IInitialStateLegacyType) => {
      return {
        ...initialState,
        values: {
          ...initialState.values,
          [event.target.name]: isCheckbox ? event.target.checked : targetValue,
        },
        dirty: true,
      };
    });
  };

  const preferredDefaultCheckParams = (
    containerType: string,
    customerType: string
  ) => {
    let setParams = {
      filter:
        (IsNullEmptyUndefined(props.id) ? "" : `Id ne '${props.id}' and `) +
        `LegacyContainerDetails/Any(k:k/ContainerType eq '${containerType}' and k/CustomerType eq '${customerType}' and k/IsDefault eq true)`,
      isEnabled: true,
    };
    setParamsData(setParams);
  };

  const onDeleteCheckParamsUpdate = (
    containerType: string,
    customerType: string
  ) => {
    let setParams = {
      filter:
        (IsNullEmptyUndefined(props.id) ? "" : `Id ne '${props.id}' and `) +
        `LegacyContainerDetails/Any(k:k/ContainerType eq '${containerType}' and k/CustomerType eq '${customerType}' and k/IsDefault eq false)`,
      isEnabled: true,
    };
    setOnDeleteCheckParams(setParams);
  };

  const handleChangeContainerType = (event: any) => {
    if (event === null) return false;

    setState((initialState: IInitialStateLegacyType) => {
      return {
        ...initialState,
        values: {
          ...initialState.values,
          containerName: event.data.ContainerName,
          description: event.data.Description,
          containerType: event.data.ContainerType,
        },
        dirty: true,
      };
    });

    if (event?.data?.ContainerType) {
      if (
        duplicateEntryValidation(
          state.values.customerType,
          event?.data?.ContainerType
        ).isValid
      ) {
        setIsAddDisabled(false);
        //API call for check record already exist or not
        if (!IsNullEmptyUndefined(event?.data?.customerType)) {
          preferredDefaultCheckParams(
            event?.data?.ContainerType,
            state.values.customerType
          );
        }
      } else {
        return false;
      }
    }
  };

  const onAddContainerClick = (e: any) => {
    const { values } = state;
    e.preventDefault();

    if (
      legacyContainers &&
      duplicateEntryValidation(values.customerType, values.containerType)
        .isValid
    ) {
      if (!IsNullEmptyUndefined(values?.containerType)) {
        setLegacyContainers([
          ...(legacyContainers as []),
          { ...(values as ILegacyDuTypeFormValueType), isNew: true },
        ]);
      }
    } else {
      setLegacyContainers([values as ILegacyDuTypeFormValueType]);
    }

    setState(iInitialStateLegacyType);
    //disable add button
    setIsAddDisabled(true);
    setPreferredCheckWarning("");
  };

  const { values } = state;
  const onSuccess = (data: any) => {
    if (data.status === 200 || data.status === 204) {
      //consolelog("apiResponse",data)
      setMessage("");
      if (data?.data?.value.length == 0) {
        state.values.isDefault = true;
      }
    }
  };

  const onDeleteCheckQuerySuccess = (data: any) => {
    if (data.status === 200 || data.status === 204) {
      if (data?.data?.value.length == 0) {
        setOnDeleteMessage("");
        setLegacyContainers(
          legacyContainers.filter(
            (x) =>
              !(
                x.customerType === itemToDelete?.customerType &&
                x.containerType === itemToDelete?.containerType
              )
          )
        );
      } else {
        setOnDeleteMessage(CANT_DELETE_MESSAGE(itemToDelete));
      }
    }
    setOnDeleteCheckParams({
      filter: "",
      isEnabled: false,
    });
  };

  const onError = (error: any) => {
    consolelog("onError callback", error);
  };

  const params = {
    service: endpoints.getDuTypePaginated(),
    skip: 0,
    take: 1,
    isEnabled: paramsData.isEnabled,
    filter: paramsData.filter,
    refetchOnWindowFocus: false,
    isPaginationRequired: true,
    key: ``,
    onError(error: any) {
      onError(error);
    },
    onSuccess(result: any) {
      onSuccess(result);
    },
  };

  const { data: apiResponse, isFetching: isApiFetchingData } =
    useGetApi(params);

  const onDeleteParams = {
    service: endpoints.getDuTypePaginated(),
    skip: 0,
    take: 1,
    isEnabled: onDeleteCheckParams.isEnabled,
    filter: onDeleteCheckParams.filter,
    refetchOnWindowFocus: false,
    isPaginationRequired: true,
    onError(error: any) {
      onError(error);
    },
    onSuccess(result: any) {
      onDeleteCheckQuerySuccess(result);
    },
  };

  const { data: onDeleteCheckAPIResponse, isFetching: isDeleteCheckFetching } =
    useGetApi(onDeleteParams);

  const onDeleteClick = (row: any) => {
    if (row?.value?.isDefault && !row?.value?.isNew) {
      onDeleteCheckParamsUpdate(
        row.value.containerType,
        row.value.customerType
      );
      setItemToDelete(row.value as ILegacyDuTypeFormValueType);
    } else {
      setLegacyContainers(
        legacyContainers.filter(
          (x) =>
            !(
              x.customerType === row.value.customerType &&
              x.containerType === row.value.containerType
            )
        )
      );
      setItemToDelete(undefined);
      setOnDeleteMessage("");
    }
  };

  const onCancelClick = (e: any) => {
    props.closeHandler(e);
  };
  const onSaveClick = (e: any) => {
    props.onSubmit(
      e,
      legacyContainers.map(({ isNew, ...rest }) => rest)
    );
  };

  const duplicateEntryValidation = (
    customerType: string | undefined,
    legacyContainerType: string | undefined
  ) => {
    let index = legacyContainers.findIndex(
      (x) =>
        x.customerType === customerType &&
        x.containerType === legacyContainerType
    );

    if (index !== -1) {
      setMessage("");
      setIsAddDisabled(true);
      return {
        isValid: false,
        message: setMessage(`Record already exists.`),
      };
    }

    if (!IsNullEmptyUndefined(legacyContainerType)) {
      if (!IsNullEmptyUndefined(customerType)) {
        preferredDefaultCheckParams(
          legacyContainerType as string,
          customerType as string
        );
      } else {
        setState((initialState: IInitialStateLegacyType) => {
          return {
            ...initialState,
            values: {
              ...initialState.values,
              isDefault: false,
            },
            dirty: true,
          };
        });
      }
      setIsAddDisabled(false);
    }
    setMessage("");
    return { isValid: true };
  };

  return (
    <>
      {
        <Modal
          small
          handleClose={props.closeHandler}
          open={props.isOpen}
          headingId="info-modal"
          closeElement="Close"
          restrictClose
        >
          <ModalHeading element="h5" style={{ color: "#e55000" }}>
            Legacy Containers
          </ModalHeading>
          {/* {props.children} */}
          {/* Legacy Container Type */}
          <Form className="o-form">
            <GridWrapper className="ln-u-push-bottom">
              <GridItem size={{ lg: "1/6", md: "1/4", sm: "1/3", xs: "1" }}>
                <SelectField
                  name={FIELDS.customerType.name}
                  label={FormInputLevels.CUSTOMERTYPE}
                  options={CustomerTypeOptions}
                  defaultValue={state.values.customerType}
                  error={message}
                  value={state.values.customerType}
                  //onChange={(e: any) => onChangecustomerType(e)}
                  onChange={(e: any) => handleChange(e)}
                  //onBlur={props.onBlur}
                  placeholder="None"
                />
              </GridItem>
              <GridItem size={{ lg: "1/6", md: "1/4", sm: "1/3", xs: "1" }}>
                <h4 style={{ fontSize: "1.125rem" }}>
                  {FormInputLevels.LEGACYCONTAINERTYPE}
                </h4>
                <AutoComplete
                  apiPath="dutypemaintenance/LegacyContainers"
                  filter={""}
                  selectedField="ContainerType"
                  className="family-Group-AutoCompleteModal"
                  searchedProperty="ContainerType"
                  name={FIELDS.containerType.name}
                  placeholder="Please select"
                  testid="autocomplete-field"
                  initialValue={state.values.containerType}
                  onSelect={(e: any) => handleChangeContainerType(e)}
                />
              </GridItem>

              <GridItem size={{ lg: "1/6", md: "1/4", sm: "1/3", xs: "1" }}>
                <TextInputField
                  name={FIELDS.containerName.name}
                  label={FormInputLevels.LEGACYCONTAINERTNAME}
                  maxLength={255}
                  value={state.values.containerName}
                  disabled
                />
              </GridItem>

              <GridItem size={{ lg: "1/6", md: "1/4", sm: "1/3", xs: "1" }}>
                <TextInputField
                  name={FIELDS.description.name}
                  label={FormInputLevels.LEGACYDESCRIPTION}
                  maxLength={255}
                  value={state.values.description}
                  disabled
                />
              </GridItem>
              {/* 
              <GridItem size={{ sm: "1/4", xs: "1" }}>
                <GridWrapper> */}
              <GridItem size={{ lg: "1/6", md: "1/4", sm: "1/3", xs: "1" }}>
                <Label>
                  <br />
                </Label>
                <Checkbox
                  label={FormInputLevels.IS_DEFAULT}
                  name={FIELDS.isDefault.name}
                  outlined
                  warning={
                    !(apiResponse && apiResponse?.data?.value.length == 0)
                      ? preferredCheckWarning
                      : ""
                  }
                  checked={state.values.isDefault == true}
                  disabled={
                    (apiResponse && apiResponse?.data?.value.length == 0) ||
                    IsNullEmptyUndefined(state.values.customerType)
                  }
                  error={props.errors?.isDefault}
                  onClick={(e: any) => {
                    handleChange(e, true);
                  }}
                />
                {!(apiResponse && apiResponse?.data?.value.length == 0) &&
                  !IsNullEmptyUndefined(preferredCheckWarning) && (
                    <FieldInfo
                      id="field-info-preferred"
                      className="has-warning"
                      warning
                    >
                      {preferredCheckWarning}
                    </FieldInfo>
                  )}
              </GridItem>

              <GridItem size={{ lg: "1/6", md: "1/4", sm: "1/3", xs: "1" }}>
                <h4 style={{ paddingTop: "0.5rem" }}></h4>
                <ButtonGroupWrapper className="ln-u-hard-top legacyButtonGroup">
                  <IconButton
                    variant="filled"
                    label={isApiFetchingData ? "..." : "Add"}
                    className=""
                    disabled={isAddDisabled || isApiFetchingData}
                    onClick={(e) => onAddContainerClick(e)}
                  >
                    <Plus />
                  </IconButton>
                </ButtonGroupWrapper>
                {/* </GridItem>
                </GridWrapper> */}
              </GridItem>
            </GridWrapper>
            <Table
              id="legacyContainerTable"
              data={legacyContainers || []}
              columns={[
                {
                  name: "Customer Type",
                  accessor: (rowData: ILegacyDuTypeFormValueType) => ({
                    value: rowData.customerType,
                  }),
                  render: ({ value }: { value: string | undefined }) => (
                    <>{IsNullEmptyUndefined(value) ? "--" : value}</>
                  ),
                },
                {
                  name: "Legacy Container Type",
                  accessor: (rowData: ILegacyDuTypeFormValueType) => ({
                    value: rowData.containerType,
                  }),
                },
                {
                  name: "Legacy Container Name",
                  accessor: (rowData: ILegacyDuTypeFormValueType) => ({
                    value: rowData.containerName,
                  }),
                },
                {
                  name: "Legacy Container Description",
                  accessor: (rowData: ILegacyDuTypeFormValueType) => ({
                    value: rowData.description,
                  }),
                },
                {
                  name: "Preferred",
                  accessor: (rowData: ILegacyDuTypeFormValueType) => ({
                    value: rowData?.isDefault,
                    row: rowData,
                  }),
                  render: ({ value, row }: { value: any; row: any }) => (
                    <>
                      {setCheckBoxData(value) ? (
                        <Tick key={Math.random()} />
                      ) : (
                        "--"
                      )}

                      {itemToDelete &&
                        itemToDelete.customerType === row?.customerType &&
                        itemToDelete.containerType === row?.containerType &&
                        !isDeleteCheckFetching &&
                        onDeleteMessage && (
                          <FieldInfo error> {onDeleteMessage}</FieldInfo>
                        )}
                    </>
                  ),
                  className: "tick_icon preferred text-center",
                },
                {
                  name: "",
                  accessor: (rowData: ILegacyDuTypeFormValueType) => ({
                    value: rowData,
                  }),
                  render: (row: ILegacyDuTypeFormValueType) => {
                    return (
                      <>
                        <IconButton
                          variant="text"
                          data-testid="delete-field"
                          className="familyGroupAdminEdit"
                          label="Pagination"
                          hideLabel
                          title="Delete"
                          onClick={(event: any) => onDeleteClick(row)}
                        >
                          <Delete />
                        </IconButton>
                      </>
                    );
                  },
                },
              ]}
            />
            <div className="ln-u-bg-color-white stickyButtonGroup">
              <ButtonGroupWrapper className="ln-u-hard-top ln-u-push-bottom duButtonGroup">
                <OutlinedButton
                  className="duButtonGroup-add"
                  onClick={(event) => onCancelClick(event)}
                >
                  Cancel
                </OutlinedButton>
                {legacyContainers.length ? (
                  <FilledButton
                    className="duButtonGroup-add"
                    type="button"
                    disabled={props.isFormValid}
                    onClick={(event) => onSaveClick(event)}
                  >
                    Save
                  </FilledButton>
                ) : (
                  <></>
                )}
              </ButtonGroupWrapper>
            </div>
            {isDeleteCheckFetching && <LoadingIndicator />}
          </Form>
        </Modal>
      }
    </>
  );
};

export default LegacyContainerPopup;
